<template>
  <base-layout pageTitle="Hello">
    <banner-card content="Start ordering now with a free delivery!" buttonText="START"></banner-card>
   <!-- <CategoriesSlider /> -->
  </base-layout>
</template>

<script>
// import CardSimple from '@/components/CardSimple.vue';
import BannerCard from '@/components/BannerCard.vue';
// import CategoriesSlider from '@/components/CategoriesSlider.vue';
export default  {
  name: 'Tab2',
  components: { BannerCard },
}
</script>